export default [
  {
    text: 'Date',
    value: 'date',
  },
  {
    text: 'Type',
    value: 'type',
  },
  {
    text: 'External Link',
    value: 'external_link',
    tooltip: 'CPCReportsAdvancedTableExternalLink',
  },
  {
    text: 'Source URL',
    value: 'source_url',
    tooltip: 'CPCReportsAdvancedTableSourceUrl',
  },
  {
    text: 'Rate',
    value: 'rate',
    tooltip: 'CPCReportsAdvancedTableRate',
  },
  {
    text: 'Unique Clickouts',
    value: 'unique_clickouts',
    tooltip: 'CPCReportsAdvancedTableUniqueClickouts',
  },
  {
    text: 'Commission',
    value: 'commission',
    tooltip: 'CPCReportsAdvancedTableCommission',
  },
];
